import {createRouter, createWebHistory,createWebHashHistory} from 'vue-router'
//import routes from './routes'


const routes = [
    {
        path:'/',
        redirect:"/register"
    },
    {
        name: 'login',
        path: '/login',
       // component: () => import('@/view/A')
       //component: () => import('@/components/view/A')
       component: () => import('@/components/login2')
    },
    {
        name: 'register',
        path: '/register',
        //component: () => import('@/components/view/B')
        component: () => import('@/components/register2')
    },
    
];


const router = createRouter({
    history: createWebHashHistory(), 
    routes
})

export default router
